import react, { Component } from "react";
import CalendarDays from "./CalendarDays";
import styled from "styled-components";
import {
	collection,
	getDocs,
	onSnapshot,
	orderBy,
	query,
	Timestamp,
	where,
} from "firebase/firestore";
import { firestore, userData } from "../../../App";
import { eventEmitter } from "../../../tools/EventEmitter";

const CalendarContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	max-width: 800px;
	margin: auto;
	-webkit-user-select: none;
	user-select: none;
`;

const Header = styled.div`
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	gap: 24px;
`;

const MonthTitle = styled.div`
	display: flex;
	flex-direction: column;
	width: 60%;
	justify-content: center;
	align-items: center;

	span {
		color: var(--color-primary);
		font-style: var(--md-sys-typescale-body-small-font-family-style);
		font-weight: var(--md-sys-typescale-body-small-font-weight);
		font-size: var(--md-sys-typescale-body-small-font-size);
		letter-spacing: var(--md-sys-typescale-body-small-tracking);
		line-height: var(--md-sys-typescale-body-small-height);
		text-transform: var(--md-sys-typescale-body-small-text-transform);
		text-decoration: var(--md-sys-typescale-body-small-text-decoration);
	}
`;

const ArrowButton = styled.button`
	position: relative;
	width: 24px;
	height: 24px;
	background: transparent;
	border: none;
	color: var(--color-on-background);
	font-size: 24px;
	line-height: 24px;
	cursor: pointer;
	transition: 0.3s;

	span {
		position: relative;
		display: block;
		width: 24px;
		height: 24px;
		font-size: 24px;
		line-height: 24px;
		z-index: 1;
	}

	&::before {
		content: "";
		position: absolute;
		top: -6px;
		left: -6px;
		width: 36px;
		height: 36px;
		background: var(--color-surface-container-highest);
		border-radius: 50%;
		opacity: 0;
		transition: 0.3s;
	}

	&:hover::before {
		top: -6px;
		left: -6px;
		width: 36px;
		height: 36px;
		opacity: 1;
	}
`;

const Body = styled.div``;

const WeekDayHeader = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`;

const WeekDay = styled.div`
	display: flex;
	flex: 1 1 calc(100% / 7);
	justify-content: center;
	align-items: center;
	height: 48px;
	text-transform: uppercase;
`;

function monthModule(month) {
	return ((month % 12) + 12) % 12;
}

export default class Calendar extends Component {
	constructor(props) {
		super(props);

		this.daysRef = react.createRef();

		this.weekdays = ["lun", "mar", "mer", "gio", "ven", "sab", "dom"];
		this.months = [
			"Gennaio",
			"Febbraio",
			"Marzo",
			"Aprile",
			"Maggio",
			"Giugno",
			"Luglio",
			"Agosto",
			"Settembre",
			"Ottobre",
			"Novembre",
			"Dicembre",
		];

		this.state = {
			usnubscribeSnapshot: null,
			currentDay: new Date(),
			cloudEvents: [],
			userColors: {},
			userData: null,
		};

		this.setSelectedDays = this.setSelectedDays.bind(this);
	}

	findEventByIdAndDelete(eventId) {
		this.setState((prevState) => ({
			cloudEvents: prevState.cloudEvents.filter(
				(event) => event.doc_id !== eventId
			),
		}));
	}

	findEventByIdAndEdit(eventId, eventData) {
		const eventIndex = this.state.cloudEvents.findIndex(
			(event) => event.doc_id === eventId
		);
		if (eventIndex !== -1) {
			const updatedEvents = [...this.state.cloudEvents];
			updatedEvents[eventIndex] = {
				...updatedEvents[eventIndex],
				...eventData,
			};
			this.setState({ cloudEvents: updatedEvents });
			return updatedEvents[eventIndex];
		}
		return null;
	}

	async loadUserColors() {
		try {
			const usersSnapshot = await getDocs(collection(firestore, "users"));
			const userColors = {};
			usersSnapshot.forEach((doc) => {
				userColors[doc.id] = doc.data().colore;
			});
			this.setState({ userColors });
		} catch (error) {
			console.error("Error loading user colors:", error);
		}
	}

	async loadFirebaseData() {
		if (!this.state.userData) return;

		const currentDate = this.state.currentDay;
		const startDate = new Date(
			currentDate.getFullYear(),
			currentDate.getMonth() - 1,
			21
		);
		const endDate = new Date(
			currentDate.getFullYear(),
			currentDate.getMonth() + 1,
			11
		);

		console.log(startDate, endDate);

		const eventRef = collection(firestore, "events");
		let contraints = [
			where("timestampStartDate", ">=", Timestamp.fromDate(startDate)),
			where("timestampStartDate", "<=", Timestamp.fromDate(endDate)),
			orderBy("timestampStartDate", "desc"),
		];

		if (this.state.userData.uid !== "I0yR09VGscWRA56pIa7jfIlRQsR2") {
			contraints = [
				where("uid", "!=", "I0yR09VGscWRA56pIa7jfIlRQsR2"),
				...contraints,
			];
		}

		const q = query(eventRef, ...contraints);

		if (this.state.unsubscribeSnapshot != null)
			this.state.unsubscribeSnapshot();

		this.setState({
			unsubscribeSnapshot: onSnapshot(
				q,
				{ includeMetadataChanges: true },
				(snapshot) => {
					let events = [...this.state.cloudEvents];

					snapshot.docChanges().forEach((change) => {
						if (change.type === "added") {
							if (
								!events.some(
									(event) => event.doc_id === change.doc.id
								)
							) {
								console.log(
									"New event: ",
									change.doc.id,
									change.doc.data()
								);
								const event = {
									doc_id: change.doc.id,
									start_date: change.doc.data().startDate,
									end_date: change.doc.data().endDate,
									uid: change.doc.data().uid,
									color:
										this.state.userColors[
											change.doc.data().uid
										] || "#FFFFFF", // Accedi al colore dallo stato
								};
								events.push(event);
							}
						} else if (change.type === "removed") {
							console.log("Removed event: ", change.doc.data());
							events = events.filter(
								(event) => event.doc_id !== change.doc.id
							);
						} else if (change.type === "modified") {
							console.log(
								"Modified event: ",
								change.doc.id,
								change.doc.data()
							);
							const event = {
								doc_id: change.doc.id,
								start_date: change.doc.data().startDate,
								end_date: change.doc.data().endDate,
								uid: change.doc.data().uid,
								color:
									this.state.userColors[
										change.doc.data().uid
									] || "#FFFFFF", // Accedi al colore dallo stato
							};
							const eventIndex = events.findIndex(
								(event) => event.doc_id === change.doc.id
							);
							if (eventIndex !== -1) {
								events[eventIndex] = {
									...events[eventIndex],
									...event,
								};
							}
						}
					});

					this.setState({ cloudEvents: events });
				},
				(error) => {
					console.error(error);
				}
			),
		});
	}

    setSelectedDays(startDate, endDate) {
        if (startDate == null && endDate == null) {
            this.daysRef.current.clearSelection();
            return;
        }
        
		this.daysRef.current.setSelection(startDate, endDate);
	}

	nextMonth = () => {
		const day = this.state.currentDay;
		const month = monthModule(day.getMonth() + 1);
		const year = month === 0 ? day.getFullYear() + 1 : day.getFullYear();
		console.log(month, year);

		this.setState(
			{
				currentDay: new Date(year, month, 1),
				cloudEvents: [],
			},
			this.loadFirebaseData
		);
	};

	previousMonth = () => {
		const day = this.state.currentDay;
		const month = monthModule(day.getMonth() - 1);
		const year =
			day.getMonth() === 0 ? day.getFullYear() - 1 : day.getFullYear();
		console.log(month, year);

		this.setState(
			{
				currentDay: new Date(year, month, 1),
				cloudEvents: [],
			},
			this.loadFirebaseData
		);
	};

	handleUserDataUpdated = (data) => {
		console.log("Froma calendar: ", data);
		this.setState({ userData: data }, this.loadFirebaseData);
	};

	async componentDidMount() {
		await this.loadUserColors();
		this.setState({ userData: userData }, this.loadFirebaseData);
		eventEmitter.on("userDataUpdated", this.handleUserDataUpdated);
	}

	componentWillUnmount() {
		eventEmitter.off("userDataUpdated", this.handleUserDataUpdated);
		if (this.state.unsubscribeSnapshot) {
			this.state.unsubscribeSnapshot();
		}
	}

	render() {
		return (
			<CalendarContainer>
				<Header>
					<ArrowButton onClick={this.previousMonth}>
						<span className="material-symbol fill">
							arrow_back_ios_new
						</span>
					</ArrowButton>
					<MonthTitle>
						<h2>{this.months[this.state.currentDay.getMonth()]}</h2>
						<span>{this.state.currentDay.getFullYear()}</span>
					</MonthTitle>
					<ArrowButton onClick={this.nextMonth}>
						<span className="material-symbol fill">
							arrow_forward_ios
						</span>
					</ArrowButton>
				</Header>
				<Body>
					<WeekDayHeader>
						{this.weekdays.map((weekday) => {
							return (
								<WeekDay>
									<p>{weekday}</p>
								</WeekDay>
							);
						})}
					</WeekDayHeader>
					<CalendarDays
						ref={this.daysRef}
						showEvents={this.state.cloudEvents}
						currentDay={this.state.currentDay}
						onChangeSelectedDay={this.props.onDateSelected}
					/>
				</Body>
			</CalendarContainer>
		);
	}
}
